import { render, staticRenderFns } from "./full-comparison-dialog-price.vue?vue&type=template&id=25ea916f&scoped=true"
import script from "./full-comparison-dialog-price.vue?vue&type=script&lang=js"
export * from "./full-comparison-dialog-price.vue?vue&type=script&lang=js"
import style0 from "./full-comparison-dialog-price.vue?vue&type=style&index=0&id=25ea916f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea916f",
  null
  
)

export default component.exports